import { render, staticRenderFns } from "./CreatorLivestreamInteractionIndex.vue?vue&type=template&id=06fd10b6&"
import script from "./CreatorLivestreamInteractionIndex.vue?vue&type=script&lang=js&"
export * from "./CreatorLivestreamInteractionIndex.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports